export interface Category {
  id: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: "variety",
    name: "综艺复盘",
    desc: "镜头、票数、赛制争议的完整时间线还原。",
    icon: "ri-live-line",
    count: 42,
  },
  {
    id: "film",
    name: "影视风波",
    desc: "定档撤档、改档与口碑反转的事件梳理。",
    icon: "ri-film-line",
    count: 36,
  },
  {
    id: "music",
    name: "音乐版权",
    desc: "词曲归属、翻唱授权与版权纠纷的来龙去脉。",
    icon: "ri-music-2-line",
    count: 28,
  },
  {
    id: "live",
    name: "直播电商",
    desc: "带货翻车、退款潮与售后链路的深度拆解。",
    icon: "ri-shopping-bag-3-line",
    count: 31,
  },
  {
    id: "contract",
    name: "合约纠纷",
    desc: "签约解约、分成分歧与工作室运营的节点复盘。",
    icon: "ri-file-paper-2-line",
    count: 24,
  },
  {
    id: "timeline",
    name: "舆论时间线",
    desc: "从一条热搜到一次公开回应，按小时拆解。",
    icon: "ri-history-line",
    count: 53,
  },
];